import axios from "axios";
import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const accessRoute = {
    SAVE_ACCOUNT: "dashboard/core/access/save",
    LIST_COMPANY: "dashboard/core/access/list-by-company",
    LIST_BY_CODE: "dashboard/core/access/list-by-access-code",
};

export default {
    // Array de fuentes de cancelación para múltiples peticiones pendientes
    _listByCompanyCancelTokens: [],

    // Cancela TODAS las peticiones pendientes de listByCompany
    cancelListByCompanyRequest() {
        this._listByCompanyCancelTokens.forEach(cancelFn => {
            try {
                cancelFn("Cancel previous request");
            } catch (e) {}
        });
        
        // Limpiar el array después de cancelar todas
        this._listByCompanyCancelTokens = [];
    },
    // Remueve un token de cancelación específico del array
    removeListByCompanyCancelToken(cancelFn) {
        const index = this._listByCompanyCancelTokens.indexOf(cancelFn);
        if (index > -1) {
            this._listByCompanyCancelTokens.splice(index, 1);
        }
    },
    save(access) {
        return new Promise(resolve => {
            const method = access.code ? 'put' : 'post';
            let code = -1;
            http[method](accessRoute.SAVE_ACCOUNT, access)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se guardó el usuario correctamente");
                        return;
                    }
                    toast.error("Error al guardar el usuario");
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(code));
        });
    },

    listByCompany(objAccess) {
        // Cancelar TODAS las solicitudes previas antes de iniciar una nueva
        this.cancelListByCompanyRequest();

        const source = axios.CancelToken.source();
        // Agregar este token al array de peticiones pendientes
        this._listByCompanyCancelTokens.push(source.cancel);

        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_COMPANY, {
                params: objAccess,
                cancelToken: source.token,
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch((error) => {
                if (axios.isCancel && axios.isCancel(error)) {
                    // Petición cancelada: no mostrar error ni modificar datos
                    newData = { info: null };
                } else {
                    toast.error("No se pudo realizar la conexión con el servidor");
                }
            }).finally(() => {
                // Remover este token específico del array cuando termine
                this.removeListByCompanyCancelToken(source.cancel);
                resolve(newData);
            });
        });
    },

    findByAccessCode(code) {
        return new Promise(resolve => {
            let newData = {};
            http.get(accessRoute.LIST_BY_CODE,
                {params: {code}})
                .then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data.info;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    }
};